export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/index.1b2759aa.worker.js");
}
